export function DocumentSerializer(data){
    if(data)
    return {
        id: data.id,
        document_name: data.document_name,
        document_owner: data.document_owner,
        document_url: data.document_url,
        document_path: data.document_path,
        document_type: data.document_type,
        action_details: data.action_details,
        date_of_insert: data.date_of_insert,
        user_of_insert: data.user_of_insert,
        sub_process_id: data.sub_process_id,
        sub_process_name: data.sub_process_name,
        domain_id: data.domain_id,
        process_id: data.process_id,
        process_name: data.process_name,
        domain_name: data.domain_name,
        status: data.status,
        mark_for_deletion: data.mark_for_deletion,
        is_approved: data.is_approved,
        is_expired: data.is_expired,
        date_of_change: data.date_of_change,
        user_of_change: data.user_of_change,
        valid_upto: data.valid_upto
    }
    return null
}

export const DocumentListSerializer = (data) => {
    const records= data&&data.content&&data.content.map((doc)=>{
        return DocumentSerializer(doc)
    }).filter(obj=>obj);

    if(data)
    return{
        records: records,
        current_page: data.current_page,
        is_first_page: data.is_first_page,
        is_last_page: data.is_last_page,
        is_sorted: data.is_sorted,
        page_size: data.page_size,
        search: data.search,
        sort_order: data.sort_order,
        sorted_column: data.sorted_column,
        total_elements: data.total_elements,
        total_pages: data.total_pages,

    }

    return null
}




